export const TextTransform = () => {
  /**
   *
   * @description - Takes in upper camel case string and adds a space between each word
   * @param value - Upper camelcase string
   * @returns
   */
  const transformUpperCamelCase = (value: string) => {
    if (value == null) {
      return '';
    }

    let textTransform = value!.match(/[A-Z][a-z]+|[0-9]+/g)!.join(' ');
    return textTransform;
  };

  return {
    transformUpperCamelCase,
  };
};
